/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { CarrouselResponse, GetApiCarrousel401, GetApiCarrousel403 } from '../placementApi.schemas.ts';

import getApiCarrouselMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Recuperation de l'ensemble des elements du carrousel dynamique de l'application mobile
 * @summary Recuperation du carrousel dynamique
 */
export const getApiCarrousel = (signal?: AbortSignal) => {
  return getApiCarrouselMutator<CarrouselResponse>({ url: `/api/carrousel`, method: 'GET', signal });
};

export const getGetApiCarrouselQueryKey = () => {
  return [`/api/carrousel`] as const;
};

export const getGetApiCarrouselQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCarrousel>>,
  TError = GetApiCarrousel401 | GetApiCarrousel403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCarrousel>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCarrouselQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCarrousel>>> = ({ signal }) => getApiCarrousel(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCarrousel>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCarrouselQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCarrousel>>>;
export type GetApiCarrouselQueryError = GetApiCarrousel401 | GetApiCarrousel403;

export function useGetApiCarrousel<
  TData = Awaited<ReturnType<typeof getApiCarrousel>>,
  TError = GetApiCarrousel401 | GetApiCarrousel403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCarrousel>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCarrousel>>,
          TError,
          Awaited<ReturnType<typeof getApiCarrousel>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiCarrousel<
  TData = Awaited<ReturnType<typeof getApiCarrousel>>,
  TError = GetApiCarrousel401 | GetApiCarrousel403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCarrousel>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCarrousel>>,
          TError,
          Awaited<ReturnType<typeof getApiCarrousel>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiCarrousel<
  TData = Awaited<ReturnType<typeof getApiCarrousel>>,
  TError = GetApiCarrousel401 | GetApiCarrousel403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCarrousel>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du carrousel dynamique
 */

export function useGetApiCarrousel<
  TData = Awaited<ReturnType<typeof getApiCarrousel>>,
  TError = GetApiCarrousel401 | GetApiCarrousel403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCarrousel>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiCarrouselQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
